import React from "react";
import DateSelect from "../DateSelect";
import PriceRange from "../PriceRange";
import AvailabilitySorting from "../Availability";
import MyInput from "../../../MyInput";

const SearchBar = ({
  currentSortingTab,
  createFilterParams,
  filterSearchInput,
  setFilterSearchInput,
  searchParams,
  setSearchParams,
}) => {
  return (
    <div className="search_bar">
      <h6>
        {currentSortingTab === "Date" && `Select ${currentSortingTab} Range`}
        {currentSortingTab === "Team" && `Search ${currentSortingTab}`}
        {currentSortingTab === "Competition" && `Search ${currentSortingTab}`}
        {currentSortingTab === "Location" && `Search ${currentSortingTab}`}
        {currentSortingTab === "Availability" && `Search ${currentSortingTab}`}
        {currentSortingTab === "Price-Range" && `Enter ${currentSortingTab}`}
      </h6>
      <div
        className="input_search"
        style={{
          borderBottom:
            currentSortingTab === "Date" || filterSearchInput.length > 0
              ? "none"
              : "1px solid var(--low-black)",
        }}
      >
        {currentSortingTab === "Team" ||
        currentSortingTab === "Competition" ||
        currentSortingTab === "Location" ? (
          <MyInput
            inputType={"text"}
            placeholderText="Search"
            value={filterSearchInput}
            func={setFilterSearchInput}
          />
        ) : (
          <>
            {currentSortingTab === "Date" && (
              <DateSelect
                createFilterParams={createFilterParams}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
              />
            )}
            {currentSortingTab === "Price-Range" && (
              <PriceRange
                createFilterParams={createFilterParams}
                currentSortingTab={currentSortingTab}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
              />
            )}
            {currentSortingTab === "Availability" && (
              <AvailabilitySorting
                currentSortingTab={currentSortingTab}
                createFilterParams={createFilterParams}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
